// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.custom_box-shadow {\n  box-shadow: 0 0px 9px -1px rgba(0, 0, 0, 0.19) !important;\n}\n/* Other-hour-entry row content: white in light mode (as before). Dark mode is\n   patched globally in theme-dark.css so the light text reads on a dark surface. */\n.other-hour-entry__content {\n  background: #fff;\n}\n.custom_opacity_reduced {\n  opacity: 0.7;\n}\n", ""]);
// Exports
module.exports = exports;
